import { EventTypes } from 'redux-segment';

import addRole from 'actions/role/addRole.action';
import editRole from 'actions/role/editRole.action';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';
export const CLEAR_ROLE_STATE = 'CLEAR_ROLE_STATE';
export const REMOVE_SAVED_ROLES_IDS = 'REMOVE_SAVED_ROLES_IDS';

export const CLEAR_ERROR = 'CLEAR_ERROR';

export const getRoles = (salonId) => ({
  ATAG: 'getRoles',
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `services/v1/role/salon/${salonId}/`,
    authenticated: true,
    types: [GET_ROLES_REQUEST, GET_ROLES_SUCCESS, GET_ROLES_FAILURE],
  },
});

// FIXME: remove this old version and use the new one directly
const addRoleOld = (name, salonId, copyFromId) => addRole({ salonId, name, copyFromId });
export { addRoleOld as addRole };

// FIXME: remove this old version and use the new one directly
const editRoleOld = (roleName, roleId, salonId) => editRole({ salonId, roleId, roleName });
export { editRoleOld as editRole };

export const deleteRole = (id, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `services/v1/salon/${salonId}/role/${id}/`,
    authenticated: true,
    types: [DELETE_ROLE_REQUEST, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAILURE],
    config: { method: 'DELETE', headers: { 'Content-Type': 'application/json' } },
    params: { id },
  },
});

export const clearRoleState = () => ({ type: CLEAR_ROLE_STATE, meta: { analytics: EventTypes.track } });
export const clearError = () => ({ type: CLEAR_ERROR });

export const removeSavedRolesIds = (idsToRemove) => ({
  type: REMOVE_SAVED_ROLES_IDS,
  idsToRemove,
  meta: { analytics: EventTypes.track },
});
